module.exports = __webpack_public_path__ + "img/qrcode_login.87db6f84.jpg";